import axios from 'axios';
import config from '../config';
import { logger } from '@/utils/screenEventsLogger';

/**
 * Get organisation data from API
 * @returns {Promise} Promise resolving to organisation data
 */
export async function apiGetOrganisation() {
  try {
    const endpoint = `${config.apiUrl}userapi/organisation`;
    const response = await axios.get(endpoint);
    return response;
  } catch (error) {
    logger.addLog(`Organisation API failed: ${error.message || 'Unknown error'}`);
    throw error;
  }
}
